module.exports = {"360322101":"上栗镇","360322102":"桐木镇","360322103":"金山镇","360322104":"福田镇","360322105":"彭高镇","360322106":"赤山镇","360322200":"鸡冠山乡","360322201":"长平乡","360322202":"东源乡","360322203":"杨岐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/360322.json
// module id = 1375
// module chunks = 0